<template>
  <su-page title="密码安全">
    <el-row class="flex al-cn ju-sp mt30" slot="content">
      <div class="passwordSecurity">
        <el-form ref="formData" :model="form" :rules="rules" label-width="80px">
          <el-form-item label="原密码" prop="current_password">
            <el-input type="password" v-model="form.current_password" autocomplete="off"></el-input>
          </el-form-item>
          <el-form-item label="新密码" prop="new_password">
            <el-input type="password" v-model="form.new_password" autocomplete="off"></el-input>
          </el-form-item>
          <el-form-item label="确认密码" prop="new_password1">
            <el-input type="password" v-model="form.new_password1" autocomplete="off"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="submitForm('formData')">提交</el-button>
            <el-button @click="resetForm('formData')">重置</el-button>
          </el-form-item>
        </el-form>
      </div>
    </el-row>
  </su-page>
</template>
<script>

import {changePassword} from "@/api/api";

export default {
  name: "passwordSecurity",
  data() {
    return {
      form: {
        current_password: '',
        new_password: '',
        new_password1: ''
      },
      rules: {
        current_password: [
          {required: true, message: '请输入原密码', trigger: 'blur'},
          {min: 6, max: 20, message: '长度在 6 到 20 个字符', trigger: 'blur'}
        ],
        new_password: [
          {required: true, message: '请输入新密码', trigger: 'blur'},
        ],
        new_password1: [
          {required: true, message: '请输入确认密码', trigger: 'blur'},
          {
            validator: (rule, value, callback) => {
              if (value !== this.form.new_password) {
                callback(new Error('两次输入的密码不一致'));
              } else {
                callback();
              }
            }, trigger: 'blur'
          }
        ]
      }
    }
  },
  mounted() {

  },
  created() {

  },
  methods: {
    // 提交表单
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          changePassword(this.form).then(res => {
            if (res.status === 200) {
              this.$message.success('修改成功');
              this.resetForm('formData'); // 重置表单
            }
          })
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    // 重置表单
    resetForm(formName) {
      this.$refs[formName].clearValidate(); //清除验证
      this.$refs[formName].resetFields(); //重置表单
    }
  }
}
</script>

<style scoped lang="scss">
@media (min-width: 750px) {
  .passwordSecurity {
    width: 50%;
  }
}

@media (max-width: 750px) {
  .passwordSecurity {
    width: 100%;
  }
}
</style>
